import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';
import { CSSProperties } from 'react';

export default function BeneficiosChippuDesktopFallback(props: {
  style?: CSSProperties;
}) {
  const { style } = props;
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: theme.spacing[3],
        ...style,
      }}
    >
      <Skeleton
        style={{
          height: 180,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
      <Skeleton
        style={{
          height: 180,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
      <Skeleton
        style={{
          height: 180,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
      <Skeleton
        style={{
          height: 180,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
    </div>
  );
}
